import type { ReactNode } from "react";
import CookieConsent from "react-cookie-consent";

export const CookieBanner = (): ReactNode => {
  return (
    <CookieConsent cookieName="baoAppCookieConsent">
      This website uses cookies to enhance the user experience. By continuing to use this website, you consent to the
      use of analytics cookies that are based solely on your interactions with this app.
    </CookieConsent>
  );
};
